module.exports = __webpack_public_path__ + "img/portrait-031.a9801765.jpg";